import { render, staticRenderFns } from "./AdjusterPortal.vue?vue&type=template&id=4bf5adbf"
import script from "./AdjusterPortal.vue?vue&type=script&lang=ts"
export * from "./AdjusterPortal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports